import { NotificacionLogDto } from "../../../types/ajustes";

export const getNotificacionLogEstadoBadge = (
  estado: NotificacionLogDto["estado"]
) => {
  switch (estado) {
    case "enviado":
      return {
        label: "Enviado",
        className: "badge bg-success-subtle text-success",
      };
    case "error":
      return {
        label: "Error",
        className: "badge bg-danger-subtle text-danger",
      };
    case "omitido":
      return {
        label: "Omitido",
        className: "badge bg-warning-subtle text-warning",
      };
    default:
      return {
        label: estado,
        className: "badge bg-secondary-subtle text-secondary",
      };
  }
};

export const getNotificacionLogDescripcion = (log: NotificacionLogDto) => {
  if (log.estado === "enviado") {
    return "Correo enviado correctamente.";
  }
  if (log.estado === "omitido") {
    return (
      log.mensaje ??
      "El envío se omitió porque no se encontraron destinatarios configurados."
    );
  }
  return log.mensaje ?? "Fallo no especificado.";
};
